/* Mobile menu behaviour: fold the groups, lift the drawer above the floating
   buttons while it is open, and nudge the hamburger until somebody has used it
   once this session. Styling is in gs-menu.css.

   WHY THE FOLD IS DONE THIS WAY. Horizon holds the drawer's child lists shut
   itself and keeps each child link at visibility: hidden until its own stagger
   runs. Overriding its max-height loses even to an inline !important — the
   drawer's own transition outranks everything in the cascade — so the fold
   toggles display instead, which nothing is animating.

   The toggle is one delegated listener on the document, in the capture phase.
   The theme re-renders the drawer on resize and on some navigations, so a
   listener bound to a button dies with it; delegation survives. On touch the
   whole Products row toggles, not just the chevron, and its own destination
   moves to "All products" at the top of the list it opens. */

(function () {
  'use strict';

  var CHEV = '<svg viewBox="0 0 16 10" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 2 8 8l7-6"/></svg>';
  var SEEN = 'gs-menu-opened';
  var HEAD = '.menu-drawer__menu-item--mainlist';

  var TOUCH = false;
  try {
    TOUCH = window.matchMedia('(hover: none), (pointer: coarse)').matches;
  } catch (err) {
    TOUCH = 'ontouchstart' in window;
  }

  function force(el, prop, value) {
    el.style.setProperty(prop, value, 'important');
  }

  /* The links are the theme's to hide; once the group is ours, show them. */
  function showLinks(ul) {
    Array.prototype.forEach.call(ul.querySelectorAll('a, .menu-drawer__animated-element'), function (el) {
      force(el, 'opacity', '1');
      force(el, 'visibility', 'visible');
      force(el, 'translate', 'none');
      force(el, 'transform', 'none');
    });
  }

  function setOpen(li, ul, open) {
    li.classList.toggle('is-open', open);
    if (open) showLinks(ul);
    force(ul, 'display', open ? 'block' : 'none');
    force(ul, 'max-height', open ? 'none' : '0px');
    force(ul, 'opacity', open ? '1' : '0');
    force(ul, 'overflow', 'visible');

    var btn = li.querySelector('.gs-mfold');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function fold() {
    var groups = document.querySelectorAll('.menu-drawer__list-item--flat');
    Array.prototype.forEach.call(groups, function (li) {
      if (li.classList.contains('gs-has-kids')) return;
      var ul = li.querySelector(':scope > .menu-drawer__menu--childlist');
      if (!ul) return;

      li.classList.add('gs-has-kids');

      var head = li.querySelector(':scope > ' + HEAD);
      var name = li.querySelector('.menu-drawer__menu-item-text');

      /* On a phone the row becomes the toggle, so put its destination back at
         the top of the list it opens. */
      if (TOUCH && head && head.getAttribute('href') && !ul.querySelector('[data-gs-all]')) {
        var first = document.createElement('li');
        first.className = 'menu-drawer__list-item';
        first.innerHTML =
          '<a class="menu-drawer__menu-item menu-drawer__menu-item--child" data-gs-all href="' +
          head.getAttribute('href') + '">All ' +
          ((name && name.textContent.trim().toLowerCase()) || 'items') + '</a>';
        ul.insertBefore(first, ul.firstChild);
      }

      setOpen(li, ul, false);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gs-mfold';
      btn.innerHTML = CHEV;
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-label', 'Show ' + ((name && name.textContent.trim()) || 'sub menu'));

      li.insertBefore(btn, li.firstChild);
    });
  }

  /* --------------------------------------------------- one delegated tap */

  var last = 0;

  function onTap(event) {
    var t = event.target;
    if (!t || !t.closest) return;

    var li = t.closest('.gs-has-kids');
    if (!li) return;

    /* A child link is a real link — leave it alone. */
    if (t.closest('.menu-drawer__menu--childlist')) return;

    var onChevron = !!t.closest('.gs-mfold');
    var onRow = !!t.closest(HEAD);
    if (!onChevron && !(TOUCH && onRow)) return;

    /* A tap fires pointerup and then a synthetic click; take the first. */
    var now = Date.now();
    if (now - last < 450) {
      event.preventDefault();
      return;
    }
    last = now;

    event.preventDefault();
    event.stopPropagation();

    var ul = li.querySelector(':scope > .menu-drawer__menu--childlist');
    if (!ul) return;

    setOpen(li, ul, !li.classList.contains('is-open'));
  }

  document.addEventListener('pointerup', onTap, true);
  document.addEventListener('click', onTap, true);

  /* ------------------------------------------------ open state on <body> */

  function watchOpen() {
    var box = document.querySelector('details.menu-drawer-container');
    if (!box) return false;

    var mark = function () {
      document.body.classList.toggle('gs-drawer-open', box.hasAttribute('open'));
    };

    new MutationObserver(mark).observe(box, { attributes: true, attributeFilter: ['open'] });
    mark();
    return true;
  }

  /* ------------------------------------------------------ the hamburger */

  var nudged = false;
  try {
    nudged = window.sessionStorage.getItem(SEEN) === '1';
  } catch (err) {
    nudged = false;
  }

  if (!nudged) {
    document.body.classList.add('gs-nudge');

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      if (!event.target.closest('.header__icon--menu, .menu-drawer-container')) return;
      document.body.classList.remove('gs-nudge');
      try { window.sessionStorage.setItem(SEEN, '1'); } catch (err) { /* fine */ }
    });
  }

  fold();
  if (!watchOpen()) window.setTimeout(watchOpen, 800);

  if ('MutationObserver' in window) {
    var pending = null;
    new MutationObserver(function () {
      window.clearTimeout(pending);
      pending = window.setTimeout(fold, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.setTimeout(fold, 1200);
})();
